import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { internalProcedureList } from "../../../../../../../services/internalProcedure.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const InternalProcedure = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(internalProcedureList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.procedureExamName,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={options}
        name="uBusIntegrationRuleMovInternalProcedures"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "internal_procedure")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
